module.exports = __webpack_public_path__ + "static/media/msop-logo.6f960542.svg";